import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import MoodForm from "@/modules/mood/admin/components/MoodForm";
import { fetchMoodsQueryOptions } from "@/modules/mood/admin/services";

export const Route = createFileRoute("/admin/_panel/_mood/mood/")({
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "mood.mood.view");
    return {
      crumb: [],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(fetchMoodsQueryOptions()),
  component: Component,
});

function Component() {
  const { t } = useTranslation("mood.admin");

  return (
    <Container title={t("Mood Settings")} className="flex h-full flex-col">
      <MoodForm />
    </Container>
  );
}
